
import React, { Component } from 'react';
import Config from '../Config'
import Spinner from '../components/Spinner';
import './css/stock.css'

class Stock extends Component {
    constructor(props) {
        super(props);

        this.state = {
            stock: null,
            isLoadError: false
        };
    }

    componentDidMount() {
        this.loadData(this.props.selectedUser);
    }
    componentDidUpdate() {
        this.loadData(this.props.selectedUser);
    }


    loadData(selectedUser) {
        if (this.loadedTechnician === selectedUser) return;
        this.loadedTechnician = selectedUser;
        const url = Config.DigibonServiceBase + "equipment?technicianCode=" + selectedUser;
        this.setState({ isLoadError: false, stock: null })
        fetch(url, Config.GetBearer())
            .then((res) => { return res.ok ? res.json() : { status: res.status } })
            .then((json) => {
                if (json.status === 401) {
                    alert("Het is noodzakelijk opnieuw in te loggen");
                    return;
                }
                this.setState({ stock: json });
            }).catch((error) => {
                console.log(error);
                this.setState({ isLoadError: true });
            });
    }
    writeValue(v, cls) {
        var className = "bg-" + cls + " text-white badge me-2";
        if (v > 0) return <span className={className}>{v}</span>;   //"<span className='badge badgle-" + cls + "'>" + v + "</span>";
        return "";
    }
    getGroup(groupName) {
        let productCodes = [...new Set(this.state.stock.filter(p => p.groupName === groupName).map(p => p.item.code))];

        //console.log(productCodes);

        return <div>
            {productCodes.map((productCode, idx2) => {
                var products = this.state.stock.filter(p => p.item.code === productCode);
                var product = products[0];
                return <div key={idx2}>

                    <div className="row clickable" key={idx2} onClick={p => this.selectProduct(product.item)}>
                        <div className="col">{product.item.code}

                        </div>
                        <div className="col">{product.item.name}</div>
                        <div className="col-1">{this.writeValue(products.filter(p => p.status !== "R" && p.status !== "T" && p.status !== "I").length, "success")}

                            {products.filter(p => p.status === "L").length > 0 &&
                                <i title="Er zijn geleende artikelen" className="fa-solid ms-4 fa-triangle-exclamation text-danger"></i>
                            }
                            {this.writeValue(products.filter(p => p.status === "R").length, "warning")}
                            {this.writeValue(products.filter(p => p.status === "T").length, "danger")}
                            {this.writeValue(products.filter(p => p.status === "I").length, "secondary")}
                        </div>
                    </div>
                    {this.state.selectedProduct && productCode === this.state.selectedProduct.code &&
                        <div>
                            <div className="row">
                                {this.getProducts(this.state.selectedProduct.code)}
                            </div>
                        </div>



                    }
                </div>


            }
            )
            }
        </div>;
    }
    getProductClass(status) {
        if (status === "T") return "card  mb-2 me-2 p-2 bg-danger";
        if (status === "A") return "card  mb-2 me-2 p-2 ";
        return "card  mb-2 me-2 p-2 bg-light";
    }

    getProducts(productCode) {
        var products = this.state.stock.filter(p => p.item.code === productCode);
        return products.map((product, idx) => {
            return <div key={idx} className="col-lg-4 col-md-6">
                <div className={this.getProductClass(product.status)}>

                    <div className="row">
                        <div className="col">KEK: {product.number}</div>
                        <div className="col">Status: {product.status}
                            {product.status === "L" &&
                                <i title="Deze status staat op geleend" className="fa-solid ms-4 fa-triangle-exclamation text-danger"></i>
                            }
                        </div>

                    </div>
                    <div className="row">
                        <div className="col">{product.serialNumber &&
                            <div>S/n : {product.serialNumber}</div>
                        }</div>
                        <div className="col">{product.internalSerialNumber &&
                            <div>Internal : {product.internalSerialNumber}</div>
                        }</div>
                    </div>



                    {product.keySafeCode &&
                        <div>Code: {product.keySafeCode}</div>
                    }
                    {product.workInformation &&
                        <div>Opmerking: {product.workInformation}</div>
                    }

                </div>
            </div>
        });
    }

    selectProduct(product) {
        if (this.state.selectedProduct && product.code === this.state.selectedProduct.code) {
            this.closeProduct();
        } else {
            this.setState({ selectedProduct: product });
        }
    }
    closeProduct() {
        this.setState({ selectedProduct: null });
    }

    render() {
        if (!this.state.stock) return <div>
            <Spinner />
        </div>;



        const header = <b><div className="row">
            <div className="col">Code</div>
            <div className="col">Naam</div>
            <div className="col-1">Voorraad</div>
        </div></b>

        let groups = [...new Set(this.state.stock.map(p => p.groupName))];

        return <div>
            <h4>Voorraad</h4>

            <div className="row">
                
                <div className="col text-end">Legenda:
                
                    <span className="ms-2 text-white bg-success badge ">voorraad</span>
                    <span className="ms-2 text-white bg-warning badge">retour</span>
                    <span className="ms-2 text-white bg-danger badge">beeindigd</span>
                    <span className="ms-2 text-white bg-secondary badge">reparatie</span>
                </div>
            </div>
            {
                this.state.isLoadError && <div className="text-danger">
                    Gegevens konden niet worden geladen. <span className="link" onClick={this.loadData.bind(this)}>Probeer opnieuw.</span>
                </div>}
            {
                this.state.stock && groups.map((group, idx) => {
                    return <div key={idx} className="mb-4">
                        <b><u>{group}</u></b>

                        <div className="ms-2">
                            {header}
                            {this.getGroup(group)}

                        </div>

                    </div>
                })
            }




        </div>
    }
}

export default Stock;